// extracted by mini-css-extract-plugin
export default {"comment-feedback-container":"comment-feedback-container","labelClass":"labelClass","textAreaClass":"textAreaClass"};